import {
  useGetList,
  useLocaleState,
  useRecordContext,
  useTranslate,
} from 'react-admin';
import {
  Timeline,
  TimelineItem,
  TimelineItemProps,
  TimelineGroup,
  useRecordEvents,
  EventAvatar,
  TimelineItemClasses,
  useEventLabel,
  EventRecord,
} from '@react-admin/ra-audit-log';
import { Funeral } from '../types';
import {
  ListItem,
  ListItemText,
  ListItemAvatar,
  Typography,
  styled,
  useMediaQuery,
  Theme,
} from '@mui/material';

const AuditTimeline = () => {
  const record = useRecordContext<Funeral>();
  const { data, isLoading } = useRecordEvents();

  const isXSmall = useMediaQuery<Theme>(theme =>
    theme.breakpoints.down('xl')
  );

  if(isXSmall) return null;

  return (
    <div style={{maxWidth: "350px", marginLeft: "15px"}}>
    <Timeline isLoading={isLoading} records={data}>
      <MyTimelineGroup />
    </Timeline>
    </div>
  );
};

const MyTimelineGroup = () => {
  return (
    <TimelineGroup>
      <MyTimelineItem />
    </TimelineGroup>
  );
};

const MyTimelineItem = (props: TimelineItemProps) => {
  const record = useRecordContext<EventRecord>(props.record);
  const translate = useTranslate();
  const [locale] = useLocaleState();
  const actionLabel = useEventLabel({ record, variant: 'record' });

  return (
    <Root>
      <ListItemAvatar>
        <EventAvatar
          alt={record.author.fullName}
          src={record.author.avatar}
          fullName={record.author.fullName}
          role="presentation"
        />
      </ListItemAvatar>
      <ListItemText
        primary={
          <Typography
            color="textPrimary"
            className={TimelineItemClasses.content}
          >
            <strong className={TimelineItemClasses.author}>
              {record.author.fullName ||
                translate(`ra-audit-log.author`, record.author)}
            </strong>
            <span className={TimelineItemClasses.action}>{actionLabel}</span>
          </Typography>
        }
        secondary={new Date(record.date).toLocaleString(locale)}
      />
    </Root>
  );
};



const PREFIX = 'RaTimelineItem';

const Root = styled(ListItem, {
    name: PREFIX,
    overridesResolver: (props, styles) => styles.root,
})(({ theme }) => ({
    '&:hover': {
        backgroundColor: theme.palette.action.hover,
    },
    [`& .${TimelineItemClasses.content}`]: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    [`& .${TimelineItemClasses.author}`]: {
        marginRight: theme.spacing(0.5),
    },
    [`& .${TimelineItemClasses.action}`]: {
        // fontSize: '14px',
    },
}));
 

export default AuditTimeline;
